import type { AlertMessage } from './FlashMessages.actions';

export interface FlashMessageState {
  alertMessages: Record<number, AlertMessage[]>;
}

export const flashMessageInitialState: FlashMessageState = {
  alertMessages: [],
};
